import { Injectable, Injector } from "@angular/core";
import { QueryNodeMessageBox } from "../QueryNodeMessageBox";
import { QueryConditionNodeOutbox } from "./QueryConditionNodeOutbox";
import { OutBoxListView } from "../../../Data/WebTraderData/OutboxListView";
import { FieldDefinitionConditions } from "../../../../../sections/webtrader/webtrader/message/fieldDefinition-conditions";
import { ResultListNodeOutbox } from "../ListEntity/ResultListNodeOutbox";
import { ServiceEnum } from "../../../ServiceEnum";
import { EntityEnum } from "../../EntityEnum";

@Injectable({
  providedIn: 'root',
})
export class QueryNodeOutBox extends QueryNodeMessageBox {

  constructor(injector: Injector) {
    super(injector, new OutBoxListView([]), 'Outbox', EntityEnum.oub, ServiceEnum.Webtrader);
    this.children!.push(new QueryConditionNodeOutbox(injector, new FieldDefinitionConditions(injector).queryOutboxConditions));
    this.children!.push(new ResultListNodeOutbox(injector));
  }

  override reset(): void {
    this.children = [];
    this.children!.push(new QueryConditionNodeOutbox(this.ioc!, new FieldDefinitionConditions(this.ioc!).queryOutboxConditions));
    this.children!.push(new ResultListNodeOutbox(this.ioc!));
  }

}